/**
 * Politica de log, por corporacao.
 *
 * Log nao e uma decisao tecnica unica: um cliente com exigencia regulatoria
 * guarda um ano, outro descarta em trinta dias, um terceiro esta investigando
 * um problema e quer gravar tudo por uma semana. Esta tela e onde isso se
 * decide, por empresa.
 *
 * Consome a API do `liberty/core`, servida pelo mesmo host que o resto do
 * accounts ja usa.
 */
export const nav = {
    section: 'Resources',
    title: 'LogPolicy',
    icon: 'database',
    route: '/politica-de-log',
    accordion: false,
    permissao: 'accounts.politica-de-log:ver',
};

export default [
    {
        path: '/politica-de-log',
        name: '/politica-de-log',
        component: () => import('./pages/PoliticaDeLogPage.vue'),
        meta: { requiresAuth: true, permissao: 'accounts.politica-de-log:ver' },
    },
];
